import type {
  IImpersonnalisationProvider,
  ImpersonnalisationResult,
} from '@/features/auth/authentification/modeles/IImpersonnalisationProvider'

import { useImpersonalisationStore } from './useImpersonnalisationStore'


export function useImpersonnalisationProvider(): IImpersonnalisationProvider {
  const store = useImpersonalisationStore()
  function getImpersonnalisationAsync(to: string): Promise<ImpersonnalisationResult> {
    return store.aficheDialogueImpersonnalisation(to)
  }

  return { getImpersonnalisationAsync }
}
